import axios from 'axios';
// import store from '@/store'

axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  // if (error.response.status === 401) {
  //   console.log('unauthorized, logging out ...');
  //   auth.logout();
  //   router.replace('/auth/login');
  // }
  return Promise.reject(error.response);
});

const API_HEADERS = { 
  'headers': {
    'Content-type': 'application/json'  
  }
}

const APIURL = process.env.VUE_APP_APIURL
const getUserToken = () => new Promise((res, rej) => {
  res(localStorage.getItem('token'))
})
 
function generateHeaders(includeToken) {
  return getUserToken().then(token => {
    if (!includeToken) return API_HEADERS;
    if (!token) return API_HEADERS;
    return {
      ...API_HEADERS,
      Authorization: `Bearer ${token}`,
    };
  });
}

function logout(){
  localStorage.clear()
  window.location.href = `${window.location.origin}/login`
}

const http = {
  get: (url, includeToken = true) =>
    generateHeaders(includeToken).then(headers =>
      axios
        .get(`${APIURL}${url}`, { headers })
        .then(response => response.data)
        .catch(err => {
          if(err.status === 401)
            logout()
          throw new Error(err.data.message) 
        })
    ),
  post: (url, data, includeToken = true) =>
    generateHeaders(includeToken).then(headers =>
      axios
        .post(`${APIURL}${url}`, data, { headers })
        .then(response => response.data)
        .catch(err => {
          if(err.status === 401)
            logout()
          throw new Error(err.data.message) 
        })
    ),
  put: (url, data = {}, includeToken = true) =>
    generateHeaders(includeToken).then(headers =>
      axios
        .put(`${APIURL}${url}`, data, { headers })
        .then(response => response.data)
        .catch(err => {
          if(err.status === 401)
            logout()
          throw new Error(err.data.message) 
        })
    ),
  delete: (url, includeToken = true) =>
    generateHeaders(includeToken).then(headers =>
      axios
        .delete(`${APIURL}${url}`, { headers })
        .then(response => response.data)
        .catch(err => {
          if(err.status === 401)
            logout()
          throw new Error(err.data.message) 
        })
    ),
};
 
export default http;